import React from 'react';
import Header from '../../../components/header';
import LogoGuidelines from './logo-guidelines';
import DownloadLogo from './download';
import { useLanguage } from '../../../helpers/language-context';
import { renderHTML } from '../../../helpers/render-html';

const OurBrand = () => {
  const { translations } = useLanguage();
  return (
    <div className="ourbrand-container">
      <Header title={translations.about.ourBrandHeader} flip={true} bgImg="/assets/images/header-bg/bg_ourServices.jpg" color="#28357B" />
      <section className="bg-[#28357B] text-white space-y-12">
        <div className="flex flex-col space-y-8 justify-center items-start mx-auto">
          <div>
              <h2 className="text-4xl md:text-5xl lg:text-6xl" dangerouslySetInnerHTML={renderHTML(translations.about.ourBrandTitle)} />
          </div>
          <div className="space-y-2 md:max-w-[80%]">
            <p className="text-sm mb-4" dangerouslySetInnerHTML={renderHTML(translations.about.ourBrandDesc)} />
            <p className="text-sm mb-4" dangerouslySetInnerHTML={renderHTML(translations.about.ourBrandDesc)} />
          </div>
        </div>
      </section>
      <LogoGuidelines />
      <DownloadLogo />
    </div>
  );
};

export default OurBrand;